import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { MatTab, MatTabGroup } from '@angular/material/tabs'
import {
  ElderBasicPaneLayoutComponent,
  ElderDataToolbarComponent,
  ElderPaneComponent,
  ElderPaneSubtitleComponent,
  ElderPlugParentFormDirective,
  ElderSelectComponent,
  ElderTableActivationDirective,
  ElderTableComponent,
  ElderTableToolbarDirective,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { BomComponentNameValidator } from '../../../../../features/validators/bom-component-name-validator'
import { BomMatcherDetailComponent } from '../../../../matcher/bom-matcher-detail/bom-matcher-detail.component'
import { ScrapRule } from '../scrap-rule'
import { ScrapRuleDetailComponent } from '../scrap-rule-detail/scrap-rule-detail.component'
import { ScrapSpec } from '../scrap-spec'
import { ScrapConsumptionSelector } from '../selectors/scrap-consumption-selector'
import { ScrapConsumptionSelectorDirective } from '../selectors/scrap-consumption-selector.directive'
import { ScrapFinishedSelector } from '../selectors/scrap-finished-selector'
import { ScrapFinishedSelectorDirective } from '../selectors/scrap-finished-selector.directive'

@Component({
  selector: 'app-scrap-spec-detail',
  templateUrl: './scrap-spec-detail.component.html',
  styleUrls: ['./scrap-spec-detail.component.scss'],
  imports: [
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
    ElderPaneSubtitleComponent,
    MatTabGroup,
    MatTab,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    ElderSelectComponent,
    ScrapConsumptionSelectorDirective,
    BomMatcherDetailComponent,
    ScrapFinishedSelectorDirective,
    ElderTableComponent,
    ElderTableActivationDirective,
    MatSort,
    ElderTableToolbarDirective,
    ElderDataToolbarComponent,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatIcon,
    MatSortHeader,
    ScrapRuleDetailComponent,
    AsyncPipe,
    ElderTranslatePipe,
    ElderPlugParentFormDirective,
  ],
})
export class ScrapSpecDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly scrapSpec$ = new BehaviorSubject<ScrapSpec>(null)

  public readonly selectedRule$ = new BehaviorSubject<ScrapRule>(null)

  public readonly ScrapConsumptionSelector = ScrapConsumptionSelector
  public readonly ScrapFinishedSelector = ScrapFinishedSelector

  public readonly bomComponentNameValidator = BomComponentNameValidator.pattern

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set scrapSpec(spec: ScrapSpec) {
    this.scrapSpec$.next(spec)
    this.selectedRule$.next(null)
  }

  public get scrapSpec(): ScrapSpec {
    return this.scrapSpec$.getValue()
  }

  private set rules(rules: ScrapRule[]) {
    const spec = this.scrapSpec
    spec.rules = rules
    this.scrapSpec = spec
  }

  private get rules(): ScrapRule[] {
    return this.scrapSpec.rules
  }

  public set selectedRule(rule: ScrapRule) {
    this.selectedRule$.next(rule)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public addRule(): void {
    const newRule = new ScrapRule()
    this.rules = this.rules ? [...this.rules, newRule] : [newRule]
    this.selectedRule = newRule
  }

  public onRemoveRules(toRemove: ScrapRule[]) {
    this.selectedRule = null

    toRemove.forEach((r) => this.rules.splice(this.rules.indexOf(r), 1))
    this.rules = [...this.rules]
  }
}
